import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=18251cdd&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=18251cdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18251cdd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18251cdd')) {
      api.createRecord('18251cdd', component.options)
    } else {
      api.reload('18251cdd', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=18251cdd&scoped=true&", function () {
      api.rerender('18251cdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24KTSa65vd27v/JS/comp/CookieBox.vue"
export default component.exports